import {Flex} from "antd";

export default function EducationPage() {
    return (
        <Flex>
            Обучение
        </Flex>
    )
}